import { AuthState, UserInfo } from './types';

const TOKEN_KEY = 'pdd_token';
const USER_KEY  = 'pdd_user';

/** Zapisz dane sesji do localStorage */
export function saveAuth(token: string, user: UserInfo): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY,  JSON.stringify(user));
}

/** Odczytaj dane sesji z localStorage; zwraca null jeśli brak lub token wygasł */
export function loadAuth(): AuthState {
  try {
    const token   = localStorage.getItem(TOKEN_KEY);
    const userStr = localStorage.getItem(USER_KEY);
    if (!token || !userStr) return { user: null, token: null };

    // Odczyt exp z payload JWT (bez weryfikacji sygnatury – serwer weryfikuje)
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && Date.now() / 1000 > payload.exp) {
      clearAuth();
      return { user: null, token: null };
    }

    return { user: JSON.parse(userStr) as UserInfo, token };
  } catch {
    return { user: null, token: null };
  }
}

/** Wyczyść dane sesji */
export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

/** Pomocnicza funkcja do wywołań API z tokenem Bearer */
export async function apiCall<T>(
  method: string,
  path:   string,
  token:  string | null,
  body?:  unknown,
): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error('Nie można połączyć się z serwerem. Upewnij się, że serwer jest uruchomiony (cd server && npm start).');
  }

  // Jeśli odpowiedź nie jest JSON-em (np. proxy zwróciło HTML z błędem), daj czytelny komunikat
  const contentType = res.headers.get('content-type') ?? '';
  if (!contentType.includes('application/json')) {
    throw new Error(`Serwer niedostępny lub zwrócił nieprawidłową odpowiedź (HTTP ${res.status}).`);
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);
  return data as T;
}
